"use strict";

const Lazy = require("./lazy");
// https://infinite-scroll.com/events.html#history
const InfiniteScroll = require("infinite-scroll");


class About {
  constructor() {}
}

class Insights {
  createInfiniteScroll() {
    this.infScroll = new InfiniteScroll(".insights-grid", {
      path: ".load-more",
      append: ".insights-grid-row",
      checkLastPage: ".load-more",
      prefill: true,
      scrollThreshold: false,
      // hideNav: ".pagnation-section",
      status: ".infinite-scroll-status",
      button: ".load-more",
      debug: false,
      onInit: function() {
        this.on("append", function(doc, page, items) {
          $(items).find('img').each((index, img) => {
            img.outerHTML = img.outerHTML;
          });

          new Lazy.LazyLoad([
            ".insights-grid-row .contents",
            ".infinite-scroll-status .infinite-scroll-request"
          ]);
        });

        this.on('last', function() {
          $('.pagnation-section').addClass('hidden');
        });
      }
    });
  }

  constructor() {
    this.createInfiniteScroll();
  }
}

class Work {
  createInfiniteScroll() {
    if ( document.querySelector('.load-more') ) {
      this.infScroll = new InfiniteScroll(".work-grid-section", {
        path: ".load-more",
        append: ".work-index-section",
        checkLastPage: ".load-more",
        prefill: true,
        // scrollThreshold: 600,
        scrollThreshold: false,
        // hideNav: ".pagnation-section",
        status: ".infinite-scroll-status",
        button: ".load-more",
        debug: false,
        onInit: function() {
          this.on("append", function(doc, page, items) {
            $(items).find('img').each((index, img) => {
              img.outerHTML = img.outerHTML;
            });

            let foobar = new Lazy.LazyLoad([
              ".side-by-side-images-section .left",
              ".side-by-side-images-section .right",
              ".infinite-scroll-status .infinite-scroll-request"
            ]);
          });
          this.on('last', function() {
            $('.pagnation-section').addClass('hidden');
          });
        }
      });
    }
  }

  constructor() {
    this.createInfiniteScroll();
  }
}

module.exports = {
  About,
  Insights,
  Work
};